import React, { useRef } from 'react';
import { TextField } from '@mui/material';

const NumberField = ({
    value,
    onTradeoffValueChange,
    id,
    isRange,
    disabled = false,
}: {
    value: number | number[],
    onTradeoffValueChange: (value: any, id: string) => void;
    id: string;
    isRange: boolean;
    disabled?: boolean;
}) => {
    const rangeMin = useRef(null);
    const rangeMax = useRef(null);

    const getRangeValue = (): number[] => {
        const min = rangeMin.current ? +(
            rangeMin.current as HTMLInputElement
        ).value : 0;
        const max = rangeMax.current ? +(
            rangeMax.current as HTMLInputElement
        ).value : 0;

        return [ min, max ].sort((a, b) => a - b);
    };

    const onNumberChange = () => {
        onTradeoffValueChange(getRangeValue(), id);
    };

    return (
        <div>
            {isRange ? (
                <>
                    <TextField
                        style={{ marginRight: 8, marginBottom: 12 }}
                        label="Min"
                        inputRef={rangeMin}
                        type="number"
                        defaultValue={(
                            value as number[]
                        )[0]}
                        onBlur={onNumberChange}
                        disabled={disabled}
                    />
                    <TextField
                        label="Max"
                        inputRef={rangeMax}
                        type="number"
                        defaultValue={(
                            value as number[]
                        )[1]}
                        onBlur={onNumberChange}
                        disabled={disabled}
                    />
                </>
            ) : (
                <TextField
                    type="number"
                    defaultValue={value}
                    onBlur={(e) => onTradeoffValueChange(+e.target.value, id)}
                    disabled={disabled}
                />
            )}
        </div>
    );
};

export default NumberField;